// Routes added by the eRecords fork; spread into AppRoutes' route table.
import { JSXElementConstructor } from 'react'
import OnCallOverview from './OnCallOverview'
import { EntraSyncPage } from './EntraSyncPanel'
import AckFromLink from './AckFromLink'
import TeamsAdmin from './TeamsAdmin'
import APIKeysPage from './APIKeys'
import ConfigPage from './ConfigPage'
import AdminPanel from './AdminPanel'
import AlertsPage from './AlertsPage'
import ReportsPage from './ReportsPage'
import AlertDetail from './AlertDetail'
import UserProfile from './UserProfile'
import ScheduleDetail from './ScheduleDetail'
import PolicyDetail from './PolicyDetail'
import ServiceDetail from './ServiceDetail'
import HeartbeatsPage from './HeartbeatsPage'
import {
  PoliciesPage,
  RotationsPage,
  SchedulesPage,
  ServicesPage,
  UsersPage,
} from './ListPages'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const erecordsRoutes: Record<string, JSXElementConstructor<any>> = {
  '/overview': OnCallOverview,
  '/alerts': AlertsPage,
  '/reports': ReportsPage,
  '/services/:serviceID/alerts': AlertsPage,
  '/services/:serviceID/alerts/:alertID': AlertDetail,
  '/alerts/:alertID': AlertDetail,
  '/escalation-policies/:policyID/alerts': AlertsPage,
  '/services': ServicesPage,
  '/services/:serviceID': ServiceDetail,
  '/services/:serviceID/heartbeat-monitors': HeartbeatsPage,
  '/escalation-policies': PoliciesPage,
  '/escalation-policies/:policyID': PolicyDetail,
  '/users': UsersPage,
  '/users/:userID': UserProfile,
  '/schedules': SchedulesPage,
  '/schedules/:scheduleID': ScheduleDetail,
  '/rotations': RotationsPage,
  '/admin': AdminPanel,
  '/admin/entra-sync': EntraSyncPage,
  '/admin/teams': TeamsAdmin,
  '/admin/api-keys': APIKeysPage,
  '/admin/config': ConfigPage,
  '/erecords/ack/:alertID': AckFromLink,
}

// The landing page: '/' redirects here instead of '/alerts'.
export const erecordsHome = '/overview'
